import { Directive, ElementRef, inject, Input, OnInit, Renderer2 } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[lvI18nPlaceholder]'
})
export class I18nPlaceholderDirective implements OnInit {
  @Input() lvI18nPlaceholder: string;

  private element = inject(ElementRef);
  private renderer = inject(Renderer2);
  private translate = inject(TranslateService);

  ngOnInit() {
    const native = this.element.nativeElement;
    this.translate
      .get(this.lvI18nPlaceholder)
      .subscribe((res) => this.renderer.setProperty(native, 'placeholder', res));
  }
}

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[lvI18nValue]'
})
export class I18nValueDirective implements OnInit {
  @Input() lvI18nValue: string;

  private element = inject(ElementRef);
  private renderer = inject(Renderer2);
  private translate = inject(TranslateService);

  ngOnInit() {
    const native = this.element.nativeElement;
    this.translate.get(this.lvI18nValue).subscribe((res) => this.renderer.setProperty(native, 'value', res));
  }
}
